import { ethers, parseEther, Typed } from 'ethers';
import payTokenAbi from '../../abi/PayToken';
import payTokenBytecode from '../../byteCode/PayToken';
import { PayToken } from '../../typechain-types';
import { utils } from 'web3';

export async function getPayTokenContract(signerAddress: string): Promise<PayToken | null> {
  const contractAddress = process.env.REACT_APP_PAY_TOKEN_CONTRACT_ADDRESS;

  if (contractAddress && window?.ethereum) {
    const provider = new ethers.BrowserProvider(window.ethereum);
    const signer = await provider.getSigner(signerAddress);
    const factory = new ethers.ContractFactory(payTokenAbi, payTokenBytecode, signer);
    return factory.attach(contractAddress) as PayToken;
  }

  return null;
}

export async function mintTokens(contract: PayToken, address: string, value: string) {
  return contract['mint(address)'](Typed.address(address), {
    value: utils.toWei(parseEther(value.slice(0, 18)), 'wei'),
  });
}

export async function estimateMintGas(contract: PayToken, address: string, value: string) {
  const contractAddress = process.env.REACT_APP_PAY_TOKEN_CONTRACT_ADDRESS;

  if (contractAddress) {
    const provider = new ethers.BrowserProvider(window?.ethereum);

    if (provider) {
      const data = contract.interface.encodeFunctionData('mint(address)', [address]);

      return provider.estimateGas({
        to: contract,
        value: utils.toWei(parseEther(value.slice(0, 18)), 'wei').slice(0, 18),
        data,
      });
    }
  }
}

export async function withdrawTokens(contract: PayToken, amount: string) {
  return contract.withdraw(utils.toWei(parseEther(amount.slice(0, 18)), 'wei').slice(0, 18));
}
